import { useState, useEffect } from "react";

const KEY = "vs_favorites";

export function getFavorites() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "[]");
  } catch {
    return [];
  }
}

function persist(list) {
  localStorage.setItem(KEY, JSON.stringify(list));
  window.dispatchEvent(new Event("favorites-changed"));
}

export function toggleFavorite(item) {
  const list = getFavorites();
  const idx = list.findIndex((x) => x.id === item.id);
  if (idx >= 0) list.splice(idx, 1);
  else list.unshift(item);
  persist(list);
  return list;
}

export function removeFavorite(id) {
  persist(getFavorites().filter((x) => x.id !== id));
}

export function useFavorites() {
  const [favorites, setFavorites] = useState(getFavorites());
  useEffect(() => {
    const handler = () => setFavorites(getFavorites());
    window.addEventListener("favorites-changed", handler);
    window.addEventListener("storage", handler);
    return () => {
      window.removeEventListener("favorites-changed", handler);
      window.removeEventListener("storage", handler);
    };
  }, []);
  return {
    favorites,
    toggle: (item) => setFavorites(toggleFavorite(item)),
    remove: (id) => removeFavorite(id),
    isFavorite: (id) => favorites.some((x) => x.id === id),
  };
}
